import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { currentlyBusyAtom, excludedAtom, workingIdMapAtom } from './atoms'
import { useUpdateFunc } from './utility'
import React, { useMemo } from 'react'
import { NodeContentUpdate } from './types'
import { Box, Button } from '@mui/material'
import { openNode } from '../../utility/TreeNavigation'
import { goToBuilder } from '../TreeActions'
import { idsForNode } from '../nodeUpdates/utility'
import { ReplacementPreviewColumn } from './UpdatePreview'
import { ConfirmCommitButton } from 'shared/ui'
import { INode } from 'shared/types/tree'

const excludeColumn = {
  title: <strong>Exclude</strong>,
  width: 50,
  rowContent(update: NodeContentUpdate) {
    return <ExcludeOneButton update={update} />
  },
}

const includeColumn = {
  title: <strong>Include</strong>,
  width: 50,
  rowContent(update: NodeContentUpdate) {
    return <IncludeOneButton update={update} />
  },
}

const titleColumn = {
  title: <strong>Node Title</strong>,
  width: 100,
  rowContent({ node: { title } }: NodeContentUpdate) {
    return title
  },
}

const typeColumn = {
  title: <strong>Node Type</strong>,
  width: 25,
  rowContent({ node: { type } }: NodeContentUpdate) {
    return type
  },
}

const previewColumn = {
  title: <strong>Preview</strong>,
  width: 100,
  rowContent(update: NodeContentUpdate) {
    return <ReplacementPreviewColumn update={update} />
  },
}

const linkColumn = {
  title: <strong>Go</strong>,
  width: 10,
  rowContent({ node }: NodeContentUpdate) {
    return <NodeLinkColumnComponent node={node} />
  },
}

function NodeLinkColumnComponent({ node }: { node: INode }) {
  const idMap = useAtomValue(workingIdMapAtom)
  return (
    <Box display="flex" flexDirection="column">
      <Button size="small" onClick={() => openNode(node, idMap)}>
        Kiddom
      </Button>
      <Button size="small" onClick={() => goToBuilder(idsForNode(node))}>
        Builder
      </Button>
    </Box>
  )
}

const updateColumn = {
  title: <strong>Update</strong>,
  width: 50,
  rowContent(update: NodeContentUpdate) {
    return <UpdateColumnComponent update={update} />
  },
}

function UpdateColumnComponent({ update }: { update: NodeContentUpdate }) {
  const busy = useAtomValue(currentlyBusyAtom)
  const updateFunc = useUpdateFunc(true)
  return (
    <ConfirmCommitButton disabled={busy} onClick={() => updateFunc(update)}>
      Update
    </ConfirmCommitButton>
  )
}

export const includedColumns = [
  titleColumn,
  typeColumn,
  linkColumn,
  previewColumn,
  excludeColumn,
  updateColumn,
]

export const excludedColumns = [
  titleColumn,
  typeColumn,
  linkColumn,
  previewColumn,
  includeColumn,
]

function ExcludeOneButton({ update: { node } }: { update: NodeContentUpdate }) {
  const [excluded, setExcluded] = useAtom(excludedAtom)
  const doExclude = () => setExcluded((prev) => [...prev, node.id])
  return (
    <Button disabled={excluded.includes(node.id)} onClick={doExclude}>
      Exclude
    </Button>
  )
}

function IncludeOneButton({ update: { node } }: { update: NodeContentUpdate }) {
  const [excluded, setExcluded] = useAtom(excludedAtom)
  const doExclude = () =>
    setExcluded((prev) => prev.filter((id) => id !== node.id))
  return (
    <Button disabled={!excluded.includes(node.id)} onClick={doExclude}>
      Include
    </Button>
  )
}
